import { type ReactNode, useState, useCallback, useMemo } from 'react';
import { Grid, type SiderProps } from 'antd';
//import { MenuOutlined } from '@ant-design/icons';
//import cn from 'classnames';

import AdminLayoutContext, { SidebarState } from './AdminLayoutContext';
import Logo from '../Logo';
import Navbar1 from '../Navbar1';
import { Outlet } from 'react-router-dom';
//import DashboardFilter from 'features/dashboard/components/DashboardFilter';

// const { Sider } = Layout;


type AdminLayoutProps = {
  className?: string;
  logo?: ReactNode;
  smallLogo?: ReactNode;
  children?: ReactNode;
  headerContent?: ReactNode;
  sidebarContent?: ReactNode;
  sidebarBreakpoint?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  sidebarCollapsedWidth?: SiderProps['collapsedWidth'];
  sidebarWidth?: SiderProps['width'];
  sidebarTheme?: SiderProps['theme'];
};

const AdminLayout = ({

  sidebarBreakpoint = 'lg',

  sidebarTheme = 'dark',
}: AdminLayoutProps) => {
  const { [sidebarBreakpoint]: isBreakpoint } = Grid.useBreakpoint();

  const useDrawer = !isBreakpoint;

  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleIsCollapsed = useCallback(() => setIsCollapsed(!isCollapsed), [isCollapsed]);

  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const toggleIsDrawerVisible = useCallback(
    () => setIsDrawerVisible(!isDrawerVisible),
    [isDrawerVisible]
  );

  const toggle = useCallback(
    () => (useDrawer ? toggleIsDrawerVisible() : toggleIsCollapsed()),
    [useDrawer, toggleIsDrawerVisible, toggleIsCollapsed]
  );

  const sidebarState = getSidebarState({ useDrawer, isCollapsed, isDrawerVisible });

  // const Sidebar = (
  //   <Sider
  //     className="admin-layout-sidebar"
  //     collapsible={!useDrawer}
  //     collapsed={isCollapsed}
  //     onCollapse={setIsCollapsed}
  //     collapsedWidth={sidebarCollapsedWidth}
  //     theme={sidebarTheme}
  //     width={sidebarWidth}
  //   >
  //     <div className="admin-layout-sidebar-logo">{logo}</div>
  //     {sidebarContent && <div className="admin-layout-sidebar-content">{sidebarContent}</div>}
  //   </Sider>
  // );

  const value = useMemo(
    () => ({ sidebarTheme, isCollapsed, useDrawer, isDrawerVisible, sidebarState, toggle }),
    [sidebarTheme, isCollapsed, useDrawer, isDrawerVisible, sidebarState, toggle]
  );

  return (
    <AdminLayoutContext.Provider value={value}>
      <header>
        <div className="container-fluid">
          <div className="row">

            <div className="col-md-3 col-sm-3 col-xs-12">
              <Logo to='' size={'small'} />

            </div>

            <div className="col-md-9 col-sm-9 col-xs-12">
              <Navbar1 />
            </div>

            <div className="col-md-12 col-sm-12 col-xs-12">
              <h2 className="registration-heading">Avanse Payment Portal</h2>
            </div>



          </div>
        </div>
      </header>
      {/* <div className="container"> */}
      {/*@RenderBody()*/}
      {/* </div> */}
      <Outlet />
    </AdminLayoutContext.Provider>
  );
};

export default AdminLayout;

const getSidebarState = ({
  useDrawer,
  isCollapsed,
  isDrawerVisible,
}: {
  useDrawer: boolean;
  isCollapsed: boolean;
  isDrawerVisible: boolean;
}) =>
  useDrawer
    ? isDrawerVisible
      ? SidebarState.OPEN_DRAWER
      : SidebarState.CLOSED_DRAWER
    : isCollapsed
      ? SidebarState.COLLAPSED_SIDEBAR
      : SidebarState.OPEN_SIDEBAR;
